import React, { createContext, useContext, useState, type FC, type ReactNode } from 'react'
import { AuthorizationErrorDialog } from './AuthorizationErrorDialog'

interface AuthorizationErrorContextValue {
  showErrorDialog: () => void
  hideErrorDialog: () => void
}

const AuthorizationErrorContext = createContext<AuthorizationErrorContextValue | undefined>(undefined)

interface AuthorizationErrorProviderProps {
  children: ReactNode
  onOrganizationSwitch?: () => void
}

export const AuthorizationErrorProvider: FC<AuthorizationErrorProviderProps> = ({
  children,
  onOrganizationSwitch = () => window.location.reload()
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  const showErrorDialog = () => {
    setIsDialogOpen(true)
  }

  const hideErrorDialog = () => {
    setIsDialogOpen(false)
  }

  return (
    <AuthorizationErrorContext.Provider value={{ showErrorDialog, hideErrorDialog }}>
      {children}
      <AuthorizationErrorDialog
        isOpen={isDialogOpen}
        onClose={hideErrorDialog}
        onOrganizationSwitch={onOrganizationSwitch}
      />
    </AuthorizationErrorContext.Provider>
  )
}

export const useAuthorizationError = () => {
  const context = useContext(AuthorizationErrorContext)
  if (!context) {
    throw new Error('useAuthorizationError must be used within AuthorizationErrorProvider')
  }
  return context
}
